import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthToken } from "../services/axios";

export default function LoggedInPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);
      setAuthToken(token);
    }

    navigate("/q-classification");
  }, [navigate]);

  return <div>Logging in...</div>;
}
